import "../../../../styles/workspace_styles/TenantAdministratorStyles/Customers/Customer.css";
import { useNavigate } from "react-router-dom";
const Customer = ({customer,setCustomer}) =>{
    const navigate = useNavigate();
    if(!customer) return null;
    return(
        <div className="customer-container">
            <div className="customer-container-header">
                <div>
                    <h3>{`${customer? customer?.external?.title:'Loading...'}`}</h3>
                    <h4>Customer details</h4>
                </div>
                <div>
                    <p onClick={() => {setCustomer(null)}}>&#10006;</p>
                </div>
            </div>
            <div className="customer-container-navigation-bar">
                <button>Manage devices</button>
                <button onClick={() => {
                    navigate(`/tenants/customers/${customer?.local?.id}/users`);
                }}>Manage users</button>
                <button>Delete customer</button>
                <button>Copy customer id</button>
            </div>
            <div className="customer-container-body">
                <div className="customer-container-body-component">
                    <p>Title</p>
                    <input defaultValue={customer?.external?.title || ''} readOnly={true}/>
                </div>
                <div className="customer-container-body-component">
                    <p>Description</p>
                    <input defaultValue={customer?.external?.description || ''} readOnly={true}/>
                </div>
                <div className="customer-container-body-component">
                    <p>Country</p>
                    <input defaultValue={customer?.external?.country || ''} readOnly={true}/>
                </div>
                <div className="customer-container-body-component">
                    <p>City</p>
                    <input defaultValue={customer?.external?.city || ''} readOnly={true}/>
                </div>
                <div className="customer-container-body-component">
                    <p>Address 1</p>
                    <input defaultValue={customer?.external?.address || ''} readOnly={true}/>
                </div>
                <div className="customer-container-body-component">
                    <p>Address 2</p>
                    <input defaultValue={customer?.external?.address2 || ''} readOnly={true}/>
                </div>
                <div className="customer-container-body-component">
                    <p>Zip/Postal code</p>
                    <input defaultValue={customer?.external?.zip || ''} readOnly={true}/>
                </div>
                <div className="customer-container-body-component">
                    <p>Email address</p>
                    <input defaultValue={customer?.external?.email || ''} readOnly={true}/>
                </div>
                <div className="customer-container-body-component">
                    <p>Phone</p>
                    <input defaultValue={customer?.external?.phone? (customer?.external?.phone === '+'? '':customer?.external?.phone):''} readOnly={true}/>
                </div>
            </div>
        </div>
    );
}
export default Customer;